var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"cover",attrs:{"src":require("@/assets/logo.png"),"alt":""}}),_c('span',{staticClass:"title hidden md:flex",style:({ color: _vm.color || 'black' })},[_vm._v("MuleEx")])])
}
var staticRenderFns = []

export { render, staticRenderFns }